import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", function () {
  const navBar = document.querySelector(".nav-bar");
  const navBurger = document.querySelector(".nav-burger");
  const navPanel = document.querySelector(".nav-panel");

  navBurger.addEventListener("click", function () {
    navBurger.classList.toggle("nav-burger-open");
    navPanel.classList.toggle("nav-panel-shown");
  });

  const yearButton = document.querySelector(".date-button");
  const yearText = document.querySelector(".date-text");

  if (yearButton && yearText) {
    let year = parseInt(yearText.textContent);
    let isDragging = false;
    let startX = 0;
    let accumulatedDiff = 0;

    function startDrag(clientX) {
      isDragging = true;
      startX = clientX;
      accumulatedDiff = 0;
      document.body.style.userSelect = "none"; // Prevent text selection
      yearButton.classList.add("active:cursor-grabbing");

      // Attach move and stop events dynamically
      document.addEventListener("mousemove", moveDrag);
      document.addEventListener("mouseup", stopDrag);
      document.addEventListener("touchmove", moveDrag);
      document.addEventListener("touchend", stopDrag);
    }

    function moveDrag(event) {
      if (!isDragging) return;
      const clientX = event.touches ? event.touches[0].clientX : event.clientX;

      let diff = (clientX - startX) / 10; // Adjust sensitivity
      accumulatedDiff += diff;
      let yearChange = Math.floor(accumulatedDiff);

      if (yearChange !== 0) {
        let newYear = Math.min(2025, Math.max(2000, year + yearChange));
        if (newYear !== year) {
          year = newYear;
          yearText.textContent = year;
          accumulatedDiff -= yearChange;
        }
      }

      startX = clientX;
    }

    function stopDrag() {
      isDragging = false;
      document.body.style.userSelect = ""; // Restore text selection
      yearButton.classList.remove("active:cursor-grabbing");

      // Remove listeners when dragging stops
      document.removeEventListener("mousemove", moveDrag);
      document.removeEventListener("mouseup", stopDrag);
      document.removeEventListener("touchmove", moveDrag);
      document.removeEventListener("touchend", stopDrag);
    }

    // Attach only the start events to the button
    yearButton.addEventListener("mousedown", (event) => startDrag(event.clientX));
    yearButton.addEventListener("touchstart", (event) => startDrag(event.touches[0].clientX));
  }

  //Map
  //Map
  //Map
  //Map
  //Map
  //Map
  //Map

  const imageContainer = document.getElementById("map-container");
  const mapImage = document.getElementById("map");

  if (imageContainer && mapImage) {
    let isDraggingMap = false;
    let scale = 1; // Initial scale of the image
    let lastX = 0;
    let lastY = 0;

    // Function to resize the image based on scale
    function resizeImage(scaleFactor) {
      scale = Math.min(Math.max(0.1, scaleFactor), 5); // Scale between 0.1x and 5x
      mapImage.style.transform = `scale(${scale})`;
    }

    // Mouse down event to start the drag
    imageContainer.addEventListener("mousedown", (e) => {
      isDraggingMap = true;
      lastX = e.clientX;
      lastY = e.clientY;
      mapImage.style.cursor = "grabbing"; // Change cursor to grabbing
    });

    // Mouse move event to drag the image and resize it
    imageContainer.addEventListener("mousemove", (e) => {
      if (!isDraggingMap) return;

      const deltaX = e.clientX - lastX;
      const deltaY = e.clientY - lastY;

      // Adjust the image's position based on the movement
      const rect = mapImage.getBoundingClientRect();
      mapImage.style.left = rect.left + deltaX + "px";
      mapImage.style.top = rect.top + deltaY + "px";

      // Update the scale based on the movement distance
      const scaleFactor = scale + (deltaY + deltaX) * 0.002; // Adjust the multiplier as needed
      resizeImage(scaleFactor);

      // Update the last position for the next move
      lastX = e.clientX;
      lastY = e.clientY;
    });

    // Mouse up event to stop dragging
    imageContainer.addEventListener("mouseup", () => {
      isDraggingMap = false;
      mapImage.style.cursor = "grab"; // Change cursor back to grab
    });

    // Mouse leave event to stop dragging if the mouse leaves the image
    imageContainer.addEventListener("mouseleave", () => {
      isDraggingMap = false;
      mapImage.style.cursor = "grab"; // Change cursor back to grab
    });

    // Function to add a point on the map based on coordinates
    // Tableau des points à ajouter sur la carte avec leurs coordonnées et titres
    const pointsContainer = document.getElementById("points-container");
    const popup = document.querySelector(".pop-up"); // Sélection du popup global

    // Liste des points fournie
    const points = [
      { x: 40, y: 20, title: "Point A", className: "point" },
      { x: 70, y: 20, title: "Point B", className: "point" },
      { x: 60, y: 70, title: "Point C", className: "point" },
      { x: 60, y: 30, title: "Point D", className: "point" },
    ];

    const points2 = [
      { x: 25, y: 40, title: "Point X", className: "point-2" },
      { x: 50, y: 60, title: "Point Y", className: "point-2" },
      { x: 35, y: 80, title: "Point Z", className: "point-2" },
    ];

    // Fonction pour ajouter un point
    function addPoint(x, y, title, className) {
      const point = document.createElement("div");
      point.classList.add(className);
      point.style.left = `${x}%`;
      point.style.top = `${y}%`;

      // Événement de clic sur le point
      point.addEventListener("click", function (event) {
        event.stopPropagation(); // Empêche la fermeture immédiate
      });

      // Ajouter le point au conteneur
      pointsContainer.appendChild(point);
    }

    // Ajouter tous les points
    [...points, ...points2].forEach(({ x, y, title, className }) =>
      addPoint(x, y, title, className)
    );

    popup.addEventListener("click", function () {
      popup.classList.add("opacity-0");
    });
  }
});
